import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import App from "./App"; // Your main App component
import "./index.css"; // Your styles
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./dashboard/data-dashboard/lib/theme";
import { Provider } from "react-redux";
import { store } from "./store";
import { HelmetProvider } from "react-helmet-async";

const LazyToastContainer = React.lazy(() =>
   import("react-toastify").then((mod) => ({ default: mod.ToastContainer }))
);

const rootElement = document.getElementById("root");
const appContent = (
   <>
      <Provider store={store}>
         <ThemeProvider>
            <HelmetProvider>
               <BrowserRouter>
                  <App />
               </BrowserRouter>
            </HelmetProvider>
         </ThemeProvider>
      </Provider>
      <React.Suspense fallback={null}>
         <LazyToastContainer
            position="top-right"
            autoClose={3500}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
            theme="light"
            toastClassName="custom-toast"
            progressClassName="custom-toast-progress"
         />
      </React.Suspense>
   </>
);

// Always use createRoot — react-snap pre-renders static HTML for SEO crawlers,
// but real users get a full client render. hydrateRoot causes mismatch errors
// because pre-rendered HTML (no auth, fixed viewport) differs from live UI.
if (rootElement.hasChildNodes()) {
   rootElement.innerHTML = "";
}
ReactDOM.createRoot(rootElement).render(appContent);
